import React, { createContext, PropsWithChildren } from 'react';

import { DF } from '../../components/DialogFactory/DialogFactory';
import DialogWrapper from '../DialogWrapper/DialogWrapper';
import useDialog, { IDialogConfig } from './useDialog';

export interface IDialogContext {
    dialogs: IDialogConfig[];
    toggleDialog: (id: DF, open?: boolean) => void;
    openDialog: <T>(id: DF, title: string, data?: T) => void;
    createDialog: (newDialog: IDialogConfig) => void;
}

export const DialogContext = createContext<IDialogContext>({
    dialogs: [],
    createDialog: () => {},
    toggleDialog: () => {},
    openDialog: () => {},
});

const DialogProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const dialog = useDialog();

    return (
        <DialogContext.Provider value={dialog}>
            <DialogWrapper />
            {children}
        </DialogContext.Provider>
    );
};

export default DialogProvider;
